// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"40":"1480ba870b50660c","5020":"aa2828c45eabc8cc","9482":"ddd8ddfc3a4462a4"}[chunkId] + ".js";
};